import { render } from "./Overview.vue?vue&type=template&id=0a96929f&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=0a96929f&lang=scss&scoped=true"
import "./Overview.vue?vue&type=style&index=1&id=0a96929f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a96929f"]])

export default __exports__